/**
 * Copyright (C) 2021 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { ClassNameMap } from '@mui/styles';
import appTheme from '../../common/theme/appTheme.json';
import { FormikFieldEnum, useAutopopulateFormikValue } from './MissionDetailsForm';
import { selectMissionPlanById } from '../../../store';
import { shallowEqual, useSelector } from 'react-redux';

export interface TitleTextFieldProps {
  styling: ClassNameMap<'label' | 'input' | 'error'>;
}

const useStyles = makeStyles({
  text: {
    '&::placeholder': { color: appTheme.primaryTextColor, opacity: 0.5 },
  },
});

const   TitleTextField = (props: TitleTextFieldProps) => {
  const { styling } = props;
  const classes = useStyles();
  const missionPlanToEdit = useSelector(selectMissionPlanById, shallowEqual);

  // Populates mission title field when editting a plan
  useAutopopulateFormikValue(FormikFieldEnum.MISSION_TITLE, missionPlanToEdit.name ? missionPlanToEdit.name : '');

  return (
    <React.Fragment>
      <Box flexBasis="48%">
        <label htmlFor="missionTitle" className={styling.label}>
          Mission Title*
        </label>
        <Field
          name="missionTitle"
          type="text"
          placeholder="Enter Title"
          className={clsx(styling.input, classes.text)}
          autoComplete="off"
        />
        <ErrorMessage component="div" name="missionTitle" className={styling.error} />
      </Box>
    </React.Fragment>
  );
};

export default TitleTextField;
